import { createBotsSlice } from 'src/store/shared/tradingBots/factory';
import { createSession, sendMessageWs } from 'src/store/shared/tradingBots/actions';
import { actionOnMessage } from '@skynet/data-ws-mm';
import {
  selectorTradingLastMessageId,
  selectorTradingSessionDetails,
} from 'src/store/retainers/bots/selectors';
import type { TradingState } from 'src/store/shared/tradingBots/types';
import { sendMessageAction } from 'src/store/shared/tradingBots/factoryActions';

const sendMessage = sendMessageAction({
  prefix: 'retainers',
  selectorTradingSessionDetails,
  selectorTradingLastMessageId,
  sendMessage: sendMessageWs,
});

export const initialState: TradingState = {
  error: null,
  groupList: null,
  groupListStatus: null,
  messageStatus: null,
  messageLog: [],
  sessionCreateStatus: null,
  sessionDetails: null,
};

const slice = createBotsSlice({
  prefix: 'retainers',
  sendMessage: sendMessageWs,
  createSession,
  onMessage: actionOnMessage,
  initialState,
});

export const retainersBotActions = { ...slice.actions, createSession, sendMessage };

export default slice.reducer;
